var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "toast-header" }, [
    _c("strong", {
      staticClass: "mr-2",
      domProps: { textContent: _vm._s(_vm.titulo) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }